import 'css-chunksrc/client/pages/costProfilesPage/resource/assignCostProfileToResource/costProfiles/styles.scss';export default {
  "costProfiles": "_costProfiles_j0677_1",
  "costProfile": "_costProfile_j0677_1",
  "selected": "_selected_j0677_20",
  "search": "_search_j0677_24",
  "input": "_input_j0677_28"
};